export const categories = [
  {
    checked: false,
    label: 'AI Ethics and Social Impact with Ai',
  },
  {
    checked: true,
    label: 'AI Fundamentals',
  },
  {
    checked: true,
    label: 'AI Research',
  },
  {
    checked: false,
    label: 'All Things Data',
  },
  {
    checked: false,
    label: 'Automotive',
  },
  {
    checked: false,
    label: 'Blockchain',
  },
  {
    checked: false,
    label: 'Computer Vision',
  },
  {
    checked: true,
    label: 'Cybersecurity',
  },
  {
    checked: false,
    label: 'Finance',
  },
  {
    checked: false,
    label: 'Future of Humankind',
  },
  {
    checked: false,
    label: 'General Seccion',
  },
  {
    checked: false,
    label: 'Generative AI',
  },{
    checked: false,
    label: 'Government',
  },
  {
    checked: false,
    label: 'Healthcare',
  },
  {
    checked: false,
    label: 'HR & Recruiting',
  },
  {
    checked: false,
    label: 'Innovation Stage',
  },
  {
    checked: false,
    label: 'Insurance',
  },
  {
    checked: false,
    label: 'Legal',
  },
  {
    checked: false,
    label: 'Manufacturing',
  },
  {
    checked: false,
    label: 'Marketing & Customer Experience',
  },
  {
    checked: false,
    label: 'Media & Entertainment',
  },
  {
    checked: false,
    label: 'ML Ops & Platforms',
  },
  {
    checked: false,
    label: 'Media & Entertainment',
  },
  {
    checked: false,
    label: 'NLP',
  },
  {
    checked: false,
    label: 'Recommender Systems',
  },
  {
    checked: false,
    label: 'Retail',
  },
  {
    checked: false,
    label: 'Roundtable',
  },
  {
    checked: false,
    label: 'Supply Chain & Logistics'
  },  
];